<template>
  <div>
    <v-stepper-step
      :step="2"
      :color='isViewOredit  ? "#9E9E9E" : "#43a047"'
      :complete="isStepCompleted(2)"
      :editable="!isViewOredit && isStepCompleted(2)"
      edit-icon="$complete"
    >
      {{ $t('templateEditDialog.templateCategory') }}
      <small v-if="isStepCompleted(2) && currentStep !== 2" class="mt-2">{{ selectedCategory }}</small>
    </v-stepper-step>
    <v-stepper-content :step="2">
      <v-select
        v-model="templateData.category"
        :items="availableCategories"
        item-value="id"
        :label="$t('templateEditDialog.selectTemplateCategory')"
        required
      >
        <template v-slot:selection="{index, item}">
          <span>{{item.name}}</span>
        </template>
        <template v-slot:item="{index, item}">
          <span>{{item.name}}</span>
          <v-spacer/>
          <span>{{item.example}}</span>
        </template>
      </v-select>
      <div class="d-flex margin-bottom" style='gap: 1rem;'>
        <v-btn
          color='#43a047'
          style='color: white;'
          :disabled='!templateData.category'
          @click='nextStep()'
        >
          {{$t('templateEditDialog.continue')}}
        </v-btn>
        <v-btn text @click='prevStep()'>
          {{$t('commonWords.back')}}
        </v-btn>
      </div>
    </v-stepper-content>
    <v-stepper-step
      :step="3"
      :color='isViewOredit  ? "#9E9E9E" : "#43a047"'
      :complete="isStepCompleted(3)"
      :editable="!isViewOredit && isStepCompleted(3)"
      edit-icon="$complete"
    >
      {{$t('templateEditDialog.templateLanguage')}}
      <small v-if="isStepCompleted(3) && currentStep !== 3" class="mt-2">{{ selectedLanguage }}</small>
    </v-stepper-step>
    <v-stepper-content :step="3">
      <v-select
        v-model="templateData.language"
        :items="availableLanguage"
        item-text="name"
        item-value="id"
        :label="$t('templateEditDialog.selectTemplateLanguage')"/>
      <div class="d-flex margin-bottom" style='gap: 1rem;'>
        <v-btn
          color='#43a047'
          style='color: white;'
          @click='nextStep()'
          :disabled='!templateData.language'
        >
          {{$t('templateEditDialog.continue')}}
        </v-btn>
        <v-btn text @click='prevStep()'>
          {{$t('commonWords.back')}}
        </v-btn>
      </div>
    </v-stepper-content>
    <v-stepper-step
      :step="4"
      :color='method === "view" ? "#9E9E9E" : "#43a047"'
      :complete="isStepCompleted(4)"
      :editable="(!isViewOredit && isStepCompleted(4)) || edit"
      :rules="[() => currentStep < 5 || !!templateData.name, () => !showNameError ]"
      edit-icon="$complete"
    >
      {{$t('commonWords.name')}}
      <small v-if="isStepCompleted(4) && currentStep !== 4" class="mt-2">{{ templateData.name }}</small>
    </v-stepper-step>
    <v-stepper-content :step="4">
      <v-text-field
        v-model="templateData.name"
        :label="$t('templates.name')"
        @input="validateIfNameIsUnique($event)"
        :error="showNameError"
        :error-messages="showNameError ? $t('campaign.duplicatedName') : ''"
        :rules="[() => !!templateData.name || $t('commonPhrases.requiredField') ]"
        required
      />
      <div class="d-flex margin-bottom" style='gap: 1rem;'>
        <v-btn
          color='#43a047'
          style='color: white;'
          @click='nextStep()'
          :disabled="inputIsNull(templateData.name) || showNameError"
        >
          {{$t('templateEditDialog.continue')}}
        </v-btn>
        <v-btn text @click='prevStep()' v-if="!isViewOredit">
          {{$t('commonWords.back')}}
        </v-btn>
      </div>
    </v-stepper-content>
    <v-stepper-step
      :step="5"
      :color='method === "view" ? "#9E9E9E" : "#43a047"'
      :complete="isStepCompleted(5)"
      :editable="(!isViewOredit && isStepCompleted(5)) || edit"
      :rules="[() => currentStep < 6 || !!templateData.text]"
      edit-icon="$complete"
    >
      {{$t('commonWords.message')}}
      <div v-if="isStepCompleted(5) && currentStep !== 5">
        <text-editor  class='text-editor' :value="templateData.text" disabled theme="bubble" />
      </div>
    </v-stepper-step>
    <v-stepper-content :step="5">
      <text-editor
        @change="templateData.text = $event"
        :label="$t('templateEditDialog.text')"
        :value="template.text"
        :maxLength="1024"
        :disabled="method === 'view'"
        :showCounter="true"
        required
        class="margin-bottom"
      />
      <div class="d-flex margin-bottom" style='gap: 1rem;'>
        <v-btn
          color='#43a047'
          style='color: white;'
          :disabled="inputIsNull(templateData.text)"
          @click='nextStep()'
        >
          {{$t('templateEditDialog.continue')}}
        </v-btn>
        <v-btn text @click='prevStep()'>
          {{$t('commonWords.back')}}
        </v-btn>
      </div>
    </v-stepper-content>
    <v-stepper-step
      :step="6"
      :color='method === "view" ? "#9E9E9E" : "#43a047"'
      :complete="isStepCompleted(6)"
      :editable="(!isViewOredit && isStepCompleted(6)) || edit"
      edit-icon="$complete"
    >
      {{$t('templateEditDialog.button')}}
      <div v-if="isStepCompleted(6) && currentStep !== 6" class="mt-2 font-weight-regular">
        <p style="color: #757575">{{ showButtonGroupType }}</p>
        <div v-if="templateData.buttonGroup === 'quickReplyButton'">
          <p style='color: #ABB7C2' v-for="(button) in templateData.actionButtons" :key="button.id">
            {{ button.title }};
          </p>
        </div>
        <div v-if="templateData.buttonGroup === 'actionButton'">
          <p style='color: #ABB7C2' v-for="(button) in templateData.actionButtons" :key="button.id">
            {{ showButtonPreview(button) }}
          </p>
        </div>
      </div>
    </v-stepper-step>
    <v-stepper-content :step="6">
      <v-radio-group
        v-model="templateData.buttonGroup"
        @change="onButtonGroupChange"
        row
      >
        <v-radio
          :label='$t("templateEditDialog.radioButtonTitles.noButton")'
          value='noButton'
          color="#171717"
          class="radio-styles"
        />
        <v-radio
          :label='$t("templateEditDialog.radioButtonTitles.actionButton")'
          value='actionButton'
          color="#171717"
          class="radio-styles"
        />
        <v-radio
          :label='$t("templateEditDialog.radioButtonTitles.quickReplyButton")'
          value='quickReplyButton'
          color="#171717"
          class="radio-styles"
        />
      </v-radio-group>
      <div v-show="templateData.buttonGroup === 'quickReplyButton'" :key="quickReplyKey">
        <v-row class="ma-0 pa-0 d-flex" style="gap: 1rem;" v-for="(button) in templateData.actionButtons" :key="button.id">
          <v-col cols="auto" class="d-flex align-center" style="width: 100%; flex-wrap: nowrap; gap: 1rem; padding: 0">
            <v-text-field
              :label="$t('templateEditDialog.quickReplyTitle')"
              v-model="button.title"
              counter="20"
              :maxlength="20"
              filled
              required
              @input="filterEmojis(button, 'title', $event)"
              @click="emojiErrorMessage = ''"
            />
            <div style="height: 56% !important; align-self: flex-start; display: flex !important; align-items: flex-end !important;">
              <v-btn
                @click="deleteActionButton(button.id)"
                depressed
                fab
                dark
                color="#f44336"
                x-small
              >
                <v-icon dark>delete</v-icon>
                <md-tooltip md-direction="bottom">
                  {{ $t('commonWords.remove') }}
                </md-tooltip>
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <v-btn
          v-if="templateData.actionButtons.length < 3"
          class="d-flex margin-bottom"
          style="gap: 13px; padding: 16px 12px; border: 1px; border-style: dashed;"
          depressed
          color="#F19D38"
          plain
          @click="createNewButton"
          >
          <v-icon
            dark
          >
            mdi-plus
          </v-icon>
        </v-btn>
        <span class="warning-text text-center" style="display: block; margin: 0 !important;">{{emojiErrorMessage}}</span>
      </div>
      <div v-show="templateData.buttonGroup === 'actionButton'" :key="actionKey" >
        <v-row class="ma-0 pa-0 d-flex" v-for="(button) in templateData.actionButtons" :key="button.id">
          <v-col cols="auto" style="max-width: 200px; width: 100%; padding: 0; align-self: center;">
            <v-select :items="typeActions"
                      item-text="name"
                      item-value="id"
                      v-model="button.content_type" filled
                      :label="$t('templateEditDialog.typeActions')"
                      @change="handleContentTypeChange(button)"
            >
            </v-select>
          </v-col>
          <v-col cols="auto">
            <v-text-field
              :label="$t('templateEditDialog.selectedOptions')"
              v-model="button.title"
              counter="20"
              :maxlength="20"
              filled
              @input="filterEmojis(button, 'title', $event)"
              @click="emojiErrorMessage = ''"
            ></v-text-field>
          </v-col>
          <v-col cols="auto" class="d-flex align-center" style="max-width: 351px; width: 100%; flex-wrap: nowrap; gap: 12px; padding: 0">
            <v-text-field
              v-if="button.content_type === 'text'"
              :label="$t('templateEditDialog.actionFieldLabels.websiteUrlLabel')"
              filled
              v-model="button.payload"
              counter="2000"
              style="flex: 1"
              required
              :maxlength="2000"
              @input="filterEmojis(button, 'payload', $event)"
              @click="emojiErrorMessage = ''"
            />
            <VPhone
              v-else v-model="button.payload"
              :placeholder="$t('chatHistoyFilter.phoneNumber')"
              required
              @input="filterEmojis(button, 'payload', $event)"
            />
          <div style="height: 56% !important; align-self: flex-start; display: flex !important; align-items: flex-end !important;">
            <v-btn
              @click="deleteActionButton(button.id)"
              depressed
              fab
              dark
              color="#f44336"
              x-small
            >
              <v-icon dark>delete</v-icon>
              <md-tooltip md-direction="bottom">
                {{ $t('commonWords.remove') }}
              </md-tooltip>
            </v-btn>
          </div>
          </v-col>
        </v-row>
        <v-btn
          v-if="templateData.actionButtons.length < 2"
          class="d-flex margin-bottom"
          style="gap: 13px; padding: 16px 12px; border: 1px; border-style: dashed;"
          depressed
          color="#F19D38"
          plain
          @click="createNewButton"
          >
          <v-icon
            dark
          >
            mdi-plus
          </v-icon>
        </v-btn>
        <span class="warning-text text-center" style="display: block; margin: 0 !important;">{{emojiErrorMessage}}</span>
      </div>
      <div class="d-flex margin-bottom" style='gap: 1rem;'>
        <v-btn
          color='#43a047'
          style='color: white;'
          :disabled="isContinueButtonDisabled"
          @click='completeStep()'
        >
          {{$t('templateEditDialog.continue')}}
        </v-btn>
        <v-btn text @click='prevStep()'>
          {{$t('commonWords.back')}}
        </v-btn>
      </div>
    </v-stepper-content>
    <v-row class="d-flex justify-space-between" v-if="(stepperCompleted || edit) && method !== 'view'" style="margin-left: 37px;">
      <div class="d-flex margin-bottom" style='gap: 1rem;'>
        <v-btn
          color="#72B168"
          style="color: white;"
          :loading="loadingCreate"
          :disabled="loadingCreate || !isEditFieldsFilled"
          @click='createTemplate(templateData)'>
          {{ $t('templateEditDialog.saveAsDraft') }}
        </v-btn>
        <v-btn text @click="$emit('close')">
          {{ $t('commonWords.cancel') }}
        </v-btn>
      </div>
      <div style="max-width: 378px; display: flex; flex-direction: column; justify-content: flex-end;
        align-items: flex-end; margin-right: 37px;">
        <v-btn
          outlined
          :loading="loadingApproval"
          :disabled="!edit || loadingApproval || !isEditFieldsFilled"
          color="#72B168"
          @click="submitForApproval"
        >
          {{ $t('templateEditDialog.sendForApproval') }}
        </v-btn>
        <span style="word-break: break-all;">
          *{{ $t('templateEditDialog.approvalMessage') }}
        </span>
      </div>
    </v-row>
  </div>
</template>

<script>
import VPhone from '@/components/VPhone'
import TextEditor from '@/components/TextEditor'
import debounce from 'lodash.debounce'
import { v4 as uuidv4 } from 'uuid'
import isTenantMixin from '@/components/mixins/isTenantMixin'

export default {
  name: 'WhatsappSteps',
  components: {
    TextEditor,
    VPhone
  },
  props: {
    template: {
      type: Object,
      required: true
    },
    edit: {
      type: Boolean,
      default: false
    },
    currentStep: {
      type: Number
    },
    stepperCompleted: {
      type: Boolean,
      default: false
    },
    method: {
      type: String
    },
    isViewOredit: {
      type: Boolean
    },
    loadingCreate: {
      type: Boolean,
      default: false
    },
    loadingApproval: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      initialActionButtons: [
        {
          id: uuidv4(),
          content_type: 'text',
          title: '',
          payload: ''
        },
        {
          id: uuidv4(),
          content_type: 'text',
          title: '',
          payload: ''
        }
      ],
      initialQuickReplyButtons: [
        {
          id: uuidv4(),
          content_type: 'quick_reply',
          title: ''
        },
        {
          id: uuidv4(),
          content_type: 'quick_reply',
          title: ''
        }
      ],
      showNameError: false,
      typeActions: [
        { id: 'text', name: this.$t('templateEditDialog.linkTitle') },
        { id: 'number', name: this.$t('templateEditDialog.phoneNumber') }
      ],
      availableCategories: [
        { id: 'UTILITY',
          name: this.$t('templates.category.utility'),
          example:
            this.$t('templateEditDialog.communicationExample') },
        { id: 'MARKETING',
          name: this.$t('templates.category.marketing'),
          example:
            this.$t('templateEditDialog.marketingExample') }
      ],
      availableLanguage: [
        { id: 'es', name: this.$t('templates.language.spanish') },
        { id: 'en', name: this.$t('templates.language.english') },
        { id: 'pt_br', name: this.$t('templates.language.portuguese') }
      ],
      templateData: {
        category: null,
        language: null,
        name: null,
        text: null,
        buttonGroup: 'noButton',
        actionButtons: []
      },
      actionKey: 100,
      quickReplyKey: 0,
      emojiErrorMessage: ''
    }
  },
  mixins: [isTenantMixin],
  created () {
    if ((this.method === 'view' || this.method === 'edit') && this.template) {
      this.templateData = {
        category: this.template.category || 'UTILITY',
        language: this.template.language || 'pt_br',
        name: this.template.name,
        text: this.template.text,
        buttonGroup: this.template.buttons && this.template.buttons.length === 0 ? 'noButton' : (this.template.buttons.some(button => button.content_type === 'text') || this.template.buttons.some(button => button.content_type === 'number') ? 'actionButton' : 'quickReplyButton'),
        actionButtons: this.template.buttons && this.template.buttons.length === 0 ? [] : this.getActionButtons(this.template.buttons)
      }
    }
  },
  computed: {
    selectedLanguage () {
      if (this.templateData.language) {
        const language = this.availableLanguage.find((language) => language.id === this.templateData.language).name
        return language
      }
      return this.$t('templates.language.portuguese')
    },
    selectedCategory () {
      if (this.templateData.category) {
        const category = this.availableCategories.find((category) => category.id === this.templateData.category).name
        return category
      }
      return this.$t('templates.category.utility')
    },
    isEditFieldsFilled () {
      return this.templateData.name !== '' && this.templateData.text !== '' && !this.isContinueButtonDisabled
    },
    isContinueButtonDisabled () {
      if (this.templateData.buttonGroup === 'actionButton') {
        return this.templateData.actionButtons.some(button => {
          return button.content_type === '' || button.title === '' || button.payload === ''
        })
      } else if (this.templateData.buttonGroup === 'quickReplyButton') {
        return this.templateData.actionButtons.length === 0 || this.templateData.actionButtons.some(button => {
          return button.title === ''
        })
      }
      return false
    },
    showButtonGroupType () {
      if (this.templateData.buttonGroup === 'actionButton') {
        return `${this.$t('templateEditDialog.typeActions')}; ${this.$t('templateEditDialog.selectedOptions')}; ${this.$t('templateEditDialog.quickReplyPayload')}`
      } else if (this.templateData.buttonGroup === 'quickReplyButton') {
        return this.$t('templateEditDialog.radioButtonTitles.quickReplyButton')
      }
      return this.$t('templateEditDialog.radioButtonTitles.noButton')
    }
  },
  methods: {
    inputIsNull (inputValue) {
      return inputValue === null || String(inputValue).trim() === ''
    },
    nextStep () {
      this.$emit('nextStep')
    },
    prevStep () {
      this.$emit('prevStep')
    },
    completeStep () {
      this.$emit('completeStep')
    },
    createNewButton () {
      const buttonStructure = {
        id: uuidv4(),
        content_type: null,
        title: '',
        payload: ''
      }
      if (this.templateData.buttonGroup === 'actionButton') {
        buttonStructure.content_type = 'text'
      } else if (this.templateData.buttonGroup === 'quickReplyButton') {
        buttonStructure.content_type = 'quick_reply'
      }
      this.templateData.actionButtons.push(buttonStructure)
    },
    deleteActionButton (id) {
      this.templateData.actionButtons = this.templateData.actionButtons.filter((button) => button.id !== id)
      if (this.templateData.actionButtons.length === 0) {
        this.templateData.buttonGroup = 'noButton'
      }
    },
    showButtonPreview (button) {
      if (button) {
        const contentTypeText = this.typeActions.filter((type) => type.id === button.content_type)[0].name
        return `${contentTypeText}; ${button.title}; ${button.payload}`
      }
      return null
    },
    createTemplate (template) {
      this.$emit('createTemplate', template)
    },
    isStepCompleted (step) {
      if (this.edit) {
        return true
      }
      return step < this.currentStep
    },
    verifyIfButtonIsQuickReply (buttons) {
      return buttons.some(button => button.content_type === 'quick_reply')
    },
    getActionButtons (buttonsArray) {
      const buttonsFormated = buttonsArray.map((button) => {
        return {
          id: uuidv4(),
          content_type: button.content_type,
          title: button.title,
          payload: button.payload
        }
      })
      return buttonsFormated
    },
    validateIfNameIsUnique: debounce(async function () {
      try {
        await this.$axios.get(`${process.env.VUE_APP_BACKEND_BASE_URL}/message-templates/validation-name`, {
          params: {
            name: this.templateData.name.trim()
          }
        })
        this.showNameError = false
      } catch (e) {
        this.showNameError = true
      }
    }, 500),
    filterEmojis (button, typeOfInput, text) {
      const { id } = button
      const emojiRegex = /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F1E6}-\u{1F1FF}]/gu
      const textWithoutEmoji = text.replace(emojiRegex, '')
      this.templateData.actionButtons = this.templateData.actionButtons.map(btn => {
        if (btn.id === id) {
          return {
            ...btn,
            [typeOfInput]: textWithoutEmoji
          }
        }
        return btn
      })
      this.emojiErrorMessage = ''
      if (this.templateData.buttonGroup === 'actionButton' && text.match(emojiRegex)) {
        this.actionKey++
        this.emojiErrorMessage = this.$t('templates.emojiErrorMessage')
      } else if (this.templateData.buttonGroup === 'quickReplyButton' && text.match(emojiRegex)) {
        this.quickReplyKey++
        this.emojiErrorMessage = this.$t('templates.emojiErrorMessage')
      }
    },
    submitForApproval () {
      const payload = {
        name: this.templateData.name,
        category: this.templateData.category
      }
      this.$emit('submitForApproval', payload)
    },
    onButtonGroupChange (value) {
      this.emojiErrorMessage = ''
      if (value === 'noButton') {
        this.templateData.actionButtons = []
      } else if (value === 'actionButton') {
        this.templateData.actionButtons = this.initialActionButtons.map(button => {
          return {
            ...button,
            title: '',
            payload: ''
          }
        })
      } else if (value === 'quickReplyButton') {
        this.templateData.actionButtons = this.initialQuickReplyButtons.map(button => {
          return {
            ...button,
            title: ''
          }
        })
      }
    },
    handleContentTypeChange (button) {
      button.title = ''
      button.payload = ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .margin-bottom {
    margin-bottom: 1rem;
  }
  .text-editor {
    margin-top: 5px;
    & ::v-deep .quill-editor .ql-container {
      color: rgba(0,0,0,.6);
      background-color: transparent !important;
      border: 0 !important;
      & .ql-editor {
        padding: 0 !important;
      }
    }
  }
</style>
